import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  private _toastr = inject(ToastrService);

  handleError(error: HttpErrorResponse, detail: string) {
    if (error?.status === 400) {
      let errorMessage = 'An unexpected error occurred.';
      const errorObj = error?.error;
      if (typeof errorObj === 'string') {
        errorMessage = errorObj;
        this._toastr.error(errorMessage, detail);
      } else if (typeof errorObj === 'object' && errorObj !== null) {
        if ('errors' in errorObj && typeof errorObj.errors === 'object') {
          const validationMessages: string[] = [];

          for (const key in errorObj.errors) {
            if (Array.isArray(errorObj.errors[key])) {
              validationMessages.push(...errorObj.errors[key]);
            }
          }

          if (validationMessages.length) {
            errorMessage = validationMessages.join('\n');
          } else if (typeof errorObj.title === 'string') {
            errorMessage = errorObj.title;
          }
        } else if ('error' in errorObj && typeof errorObj.error === 'string') {
          errorMessage = errorObj.error;
        } else if ('message' in errorObj && typeof errorObj.message === 'string') {
          errorMessage = errorObj.message;
        }
        this._toastr.error(errorMessage, detail);
      }
    } else if (error.status === 0) {
      detail = 'Unable to access the resource. Please check your network connection.';
      this._toastr.error(detail, 'Network Error');
    } else if (error.status === 401) {
      return throwError(() => error);
    } else if (error.status === 403) {
      detail = 'Access denied. Please check your permissions.';
      this._toastr.error(detail, 'Forbidden Access');
    } else {
      this._toastr.error(detail, 'An Error Occurred');
    }
    return throwError(() => new Error(detail, { cause: error.error }));
  }
}
